import axios from 'axios'
import Env from 'Env'
import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'
import { useState } from 'react'
import { Fragment } from 'react'
import { useForm } from 'react-hook-form'

export default function ContactSupportForm() {
  const { register, handleSubmit, reset } = useForm()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [successNotice, setSuccessNotice] = useState(false)
  const submitForm = async (data: any) => {
    if (isSubmitting) return
    setIsSubmitting(true)
    const resp = await axios({
      method: 'POST',
      data: { data },
      baseURL: Env.ApiUrl,
      url: '/contact-responses',
    }).then(() => {
      setIsSubmitting(false)
      setSuccessNotice(true)
      setTimeout(() => {
        setSuccessNotice(false)
      }, 5000)
      reset()
    })
  }
  return (
    <Fragment>
      <section className="md:pt-20 md:pb-[200px] py-12">
        <div className="container">
          <div className="contact-support-form max-w-[744px] mx-auto">
            <AnimatePresence>
              {successNotice ? (
                <motion.div
                  initial={{ y: -5, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: -5, opacity: 0 }}
                  transition={{ type: 'tween' }}
                  className="mb-10 w-full p-4 bg-green-200 border border-green-500 rounded-md"
                >
                  Submission Successful. You will soon receive a reply from our Support Team!
                </motion.div>
              ) : null}
            </AnimatePresence>
            <div className="text-lg text-[#333] mb-14">
              <p>Please describe the issue you are encountering, including any details that you think may help us solve it for you. We will dig in and be in touch soon!</p>
            </div>
            <form onSubmit={handleSubmit((data) => submitForm(data))} className="flex flex-wrap">
              <div className="md:w-1/2 md:pr-2 w-full mb-5">
                <select {...register('OperatingSystem')} required className="form-select px-4 py-3 w-full border-gray-300">
                  <option value="">Operating System</option>
                  <option value="IOS">iOS</option>
                  <option value="MacOS">Mac OSX</option>
                  <option value="Android">Android</option>
                  <option value="Windows">Windows</option>
                  <option value="Linux">Linux</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="md:w-1/2 md:pl-2 w-full mb-5">
                <input {...register('OSVersion')} required type="text" placeholder="OS Version" className="form-input px-4 py-3 w-full border-gray-300" />
              </div>
              <div className="w-full mb-5">
                <input {...register('EmailAddress')} required type="email" placeholder="Email Address" className="form-input px-4 py-3 w-full border-gray-300" />
              </div>
              <div className="w-full mb-5">
                <textarea
                  minLength={5}
                  {...register('Content')}
                  required
                  placeholder="Please describe the issue you're experiencing."
                  rows={6}
                  className="mt-1 block w-full border-gray-300"
                ></textarea>
              </div>
              <button disabled={isSubmitting} type="submit" className={`btn-orange flex ml-auto ${isSubmitting && 'cursor-not-allowed'}`}>
                {isSubmitting ? 'Sending...' : 'Send to Support Team'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </Fragment>
  )
}
